// Battleplan map types for rendering deployment maps
// All coordinates are on a 60" wide x 44" tall grid in 0.5" increments
// MAINTENANCE: Objective types and their colors are duplicated in two places that
// must be updated together when a new GHB/edition adds objective types:
//   - the color map `objectiveColorClass` + scoped CSS in
//     packages/frontend/src/modules/battleview/components/BattleplanMap.vue
//   - the editor palette in packages/studio/src/components/BattleplanMap.vue
//     and its map-editor objective picker.
// See docs/superpowers/specs/2026-06-01-battleplan-authoring-tool-design.md (§6).
export var ObjectiveType;
(function (ObjectiveType) {
    ObjectiveType["Regular"] = "regular";
    ObjectiveType["Primary"] = "primary";
    ObjectiveType["Secondary"] = "secondary";
    ObjectiveType["Oakenbrow"] = "oakenbrow";
    ObjectiveType["Gnarlroot"] = "gnarlroot";
    ObjectiveType["Heartwood"] = "heartwood";
    ObjectiveType["Winterleaf"] = "winterleaf";
    ObjectiveType["GoldenLions"] = "golden_lions";
    ObjectiveType["SunSeekers"] = "sun_seekers";
    ObjectiveType["Heldenhain"] = "heldenhain";
    ObjectiveType["Sigmarite"] = "sigmarite";
})(ObjectiveType || (ObjectiveType = {}));
export var TerrainType;
(function (TerrainType) {
    TerrainType["Ruin"] = "ruin";
    TerrainType["Obscuring"] = "obscuring";
    TerrainType["PlaceOfPower"] = "place_of_power";
})(TerrainType || (TerrainType = {}));
export var TerrainSize;
(function (TerrainSize) {
    TerrainSize["Small"] = "small";
    TerrainSize["Medium"] = "medium";
    TerrainSize["Large"] = "large";
})(TerrainSize || (TerrainSize = {}));
export var ZoneType;
(function (ZoneType) {
    ZoneType["Attacker"] = "attacker";
    ZoneType["Defender"] = "defender";
    ZoneType["Other"] = "other";
})(ZoneType || (ZoneType = {}));
export var Mirror;
(function (Mirror) {
    Mirror["X"] = "x";
    Mirror["Y"] = "y";
    Mirror["Both"] = "both";
})(Mirror || (Mirror = {}));
